import { apiClient } from "./ApiConfig";
import { IReportData } from "../utils/Interfaces";
import { fetchCsvFromUrl, downloadCsvFile } from "../utils/CsvUtils";

export const ISSUE_TYPE_MAP: Record<string, string> = {
  "Item Not Received": "item_not_received",
  "Item Not as Described": "item_not_as_described",
  "Damaged Item": "damaged_item",
  "Counterfeit or Fake Item": "counterfeit_or_fake_item",
  "Unauthorized Transaction": "unauthorized_transaction",
};

export const reportApi = {
  exportAnnualReport: (year: number) => {
    return apiClient.get(`/report/export_annual_report?year=${year}`);
  },

  getAnnualReportData: async (url: string): Promise<IReportData[]> => {
    return fetchCsvFromUrl(url);
  },

  downloadCsv: (url: string, filename: string) => {
    downloadCsvFile(url, filename);
  },

  reportOrderIssue: (orderId: number, issueType: string, message: string) => {
    return apiClient.post(`/report/orders/${orderId}/report-issue`, {
      issue_type: issueType,
      message,
    });
  },
};

export default reportApi;
